import React, { forwardRef } from 'react';
import {
    Chart as ChartJS,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';

ChartJS.register(
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
);

const RadarChart = forwardRef(({ categoryScores }, ref) => {
    // categoryScores is expected to be an object: { "Career": 15, "Health": 12, ... }

    const labels = Object.keys(categoryScores);
    const dataValues = Object.values(categoryScores);

    const data = {
        labels: labels,
        datasets: [
            {
                label: 'Your Wheel of Life',
                data: dataValues,
                backgroundColor: 'rgba(127, 103, 91, 0.2)', // #7F675B (earth-500)
                borderColor: 'rgba(127, 103, 91, 1)',
                borderWidth: 2,
                pointBackgroundColor: 'rgba(127, 103, 91, 1)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgba(127, 103, 91, 1)',
            },
            {
                label: 'Ideal Balance (Max)',
                data: [20, 20, 20, 20, 20],
                backgroundColor: 'transparent',
                borderColor: 'rgba(168, 162, 158, 0.4)', // stone-400
                borderWidth: 1,
                pointRadius: 0,
                borderDash: [5, 5],
            }
        ],
    };

    const options = {
        scales: {
            r: {
                angleLines: { color: 'rgba(214, 211, 209, 0.6)' },
                grid: { color: 'rgba(214, 211, 209, 0.6)' },
                suggestedMin: 0,
                suggestedMax: 20,
                ticks: {
                    stepSize: 5,
                    backdropColor: 'transparent',
                    font: { family: 'Inter', size: 10 }
                },
                pointLabels: {
                    font: { family: 'Outfit', size: 12, weight: '600' },
                    color: '#57534e'
                }
            },
        },
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    font: { family: 'Inter' },
                    usePointStyle: true,
                }
            }
        },
        maintainAspectRatio: false,
        responsive: true
    };

    return (
        <div className="w-full h-[400px]">
            {/* Pass the forwarded ref to the Radar component */}
            <Radar ref={ref} data={data} options={options} />
        </div>
    );
});

export default RadarChart;
